export default "__VITE_ASSET__87jYeI6z__"